import dayjs from 'dayjs'
import { useEffect } from 'react'
import { FaEye } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'

import {
  setOrderList,
  setOrderTotalItems,
  sortList
} from 'application/store/orders'

import { Container, Link, PageTitle, Table } from 'view/components'
import { toMoney } from 'view/helpers'

import { handleListOrder } from 'application/usecases/handle-list-order'
import { toast } from 'react-toastify'
import { PaginationOrders } from 'view/components/pagination-order'
import * as S from './styles'

export const ListOrderPage = () => {
  const orders = useSelector((state) => state.orders)
  const token = JSON.parse(localStorage.getItem('@barrosAuth'))
  const dispatch = useDispatch()

  useEffect(() => {
    handleListOrder
      .handle({
        cCliente: Number(token?.clientsId)
      })
      .then((res) => {
        if (!res.data.Pedido || !res.data.cRegRetorno) throw new Error()

        dispatch(
          setOrderList(
            res.data.Pedido.sort(
              (a, b) => new Date(b?.dtEmissao) - new Date(a?.dtEmissao)
            )
          )
        )

        dispatch(setOrderTotalItems(res.data.cRegRetorno))
      })
      .catch(() => toast.error('Não foi possível listar os pedidos'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, orders.page])

  const header = [
    {
      label: 'Número',
      sortCheckerName: 'code',
      click: () =>
        dispatch(
          sortList({ sortCheckerName: 'code', fieldToSort: 'cPedExterno' })
        )
    },
    {
      label: 'Abertura',
      sortCheckerName: 'date',
      click: () =>
        dispatch(
          sortList({ sortCheckerName: 'date', fieldToSort: 'dtEmissao' })
        )
    },
    { label: 'Status' },
    { label: 'PDV Interno', className: 'hiden-mobile' },
    { label: 'Status PDV', className: 'hiden-mobile' },
    { label: 'Nota Fiscal', className: 'hiden-mobile' },
    { label: 'Chave NFE', className: 'hiden-mobile' },
    { label: 'Emissão NF', className: 'hiden-mobile' },
    {
      label: 'Valor',
      sortCheckerName: 'value',
      click: () =>
        dispatch(
          sortList({ sortCheckerName: 'value', fieldToSort: 'vPedTotal' })
        )
    }
  ]

  return (
    <Container>
      <PageTitle>Pedidos</PageTitle>
      <div className="table-container" style={{ overflowX: 'auto' }}>
        <Table header={header} sortList={orders.sortList}>
          {orders.orderList
            ? orders.orderList
                .slice(orders.page * 10, orders.page * 10 + 10)
                .map((item) => {
                  return (
                    <tr key={item.cPedido}>
                      <td>{item.cPedExterno}</td>
                      <td>{dayjs(item.dtEmissao).format('DD/MM/YY')}</td>
                      <td>
                        <S.Status color="rgba(255, 127, 39, .3)">
                          {item.dFases}
                        </S.Status>
                      </td>
                      <td className="hiden-mobile">{item.cPedERP}</td>
                      <td className="hiden-mobile">
                        {item.cStatusPedido && (
                          <S.Status color="rgba(255, 127, 39, .3)">
                            {item.cStatusPedido}
                          </S.Status>
                        )}
                      </td>
                      <td className="hiden-mobile">{item.cNumeroNF}</td>
                      <td className="hiden-mobile">
                        {item.cChaveNFE && (
                          <a
                            href={`https://www.consultadanfe.com/?chave=${item.cChaveNFE}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.cChaveNFE}
                          </a>
                        )}
                      </td>
                      <td className="hiden-mobile">
                        {item.dDtNF && item.dDtNF !== '0000-00-00'
                          ? dayjs(item.dDtNF).format('DD/MM/YY')
                          : ''}
                      </td>
                      <td>{toMoney(item.vPedTotal)}</td>
                      <S.Td>
                        <Link
                          to={`/pedidos/${item.cPedido}`}
                          color="--color-green"
                          small
                        >
                          <FaEye />
                        </Link>
                      </S.Td>
                    </tr>
                  )
                })
            : ''}
        </Table>
      </div>

      <PaginationOrders />
    </Container>
  )
}
